"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeButton = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var UpgradeTelemetry_1 = require("./UpgradeTelemetry");
var styles = __importStar(require("./UpgradeButton.css"));
var UpgradeButton = function (_a) {
    var telemetryOrigin = _a.telemetryOrigin, onClick = _a.onClick;
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    return (react_1.default.createElement("div", { className: styles.upgradeButtonGradient },
        react_1.default.createElement(kaleidoscope_1.Button, { className: styles.noBoxShadow, type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
                (0, UpgradeTelemetry_1.fireUpgradeStepTelemetry)(telemetry, telemetryOrigin, "browse_plans");
                window.location.href = "/#/settings/subscription";
                if (onClick)
                    onClick();
            } },
            react_1.default.createElement(icons_1.Upgrade, null),
            "Explore upgrade")));
};
exports.UpgradeButton = UpgradeButton;
